import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';

export default class LayoutTestUIListener extends UIListener {

    constructor() {
        super();
    }
}

ComponentManager.setUIListener('LayoutTestUIListener', LayoutTestUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('ModulAViewExtension.UIListeners.LayoutTestUIListener', LayoutTestUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');